/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import IntraOPChart from './intra-op-chart';
import IntraOPChartDetail from './intra-op-chart-detail';
import IntraOPChartUpdate from './intra-op-chart-update';
import IntraOPChartDeleteDialog from './intra-op-chart-delete-dialog';

const IntraOPChartRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<IntraOPChart />} />
    <Route path="new" element={<IntraOPChartUpdate />} />
    <Route path=":id">
      <Route index element={<IntraOPChartDetail />} />
      <Route path="edit" element={<IntraOPChartUpdate />} />
      <Route path="delete" element={<IntraOPChartDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default IntraOPChartRoutes;
